export default __webpack_public_path__ + "static/media/S500W_Gallery_04.e0837871.jpg";